import React, { useCallback, useEffect, useState, useRef } from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import ContentItem from './ui/ContentItem/ContentItem';
import { CONTENT_ITEM_KEYS, CONTENT_ITEM_TYPES } from './constants';
import { Guid } from 'js-guid';

export const CreateContent = ({ onAdd, onChange, initialValues, label, onDelete }) => {
  const [items, setItems] = useState([]);
  const [lastAddedId, setLastAddedId] = useState(null);
  const [deletedItems, setDeletedItems] = useState([]);
  const newItemRef = useRef(null);

  const handleFileChange = (id, file) => {
    const newGuid = new Guid().toString();
    setItems((prevItems) =>
      prevItems.map((item) => {
        console.log('changes', id, prevItems);
        if (item.id === id) {
          if (item.type === 'TextContentItem') {
            const newValue = { ...item, content: file };

            onChange(newValue);
            console.log('new', newValue);
            return newValue;
          } else {
            const newValue = { ...item, id: newGuid, content: file };

            onChange({ ...item, newGuid, content: file });
            return newValue;
          }
        } else {
          return item;
        }
      }),
    );
  };

  const handleSliderChange = useCallback((id, files) => {
    setItems((prevItems) => {
      return prevItems.map((item) => {
        if (item.id === id) {
          const newItem = {
            ...item,
            content: Array.from(files).map((i) => ({
              imgPath: i,
            })),
          };
          onChange(newItem);
          return newItem;
        } else {
          return item;
        }
      });
    });
  }, []);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedItems = Array.from(items);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);
    setItems(reorderedItems);
  };

  const handleAddElement = (value) => {
    const newId = Guid.newGuid().toString();
    const newValue = {
      content: value === 'ImageSliderContentItem' ? [] : value === 'TextContentItem' ? '' : null,
      id: newId,
      label: CONTENT_ITEM_TYPES[value],
      type: value,
    };
    onAdd(newValue);
    setItems((prev) => [...prev, newValue]);
    setLastAddedId(newId);
  };

  useEffect(() => {
    if (initialValues) {
      setItems(
        initialValues.map((i) => {
          return {
            content: i[CONTENT_ITEM_KEYS[i.discriminator]],
            id: i.guid,
            label: CONTENT_ITEM_TYPES[i.discriminator],
            type: i.discriminator,
          };
        }),
      );
    }
  }, []);
  
  useEffect(() => {
    if (lastAddedId) {
      const element = document.getElementById(`content-item-${lastAddedId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        const focusableElement = element.querySelector('input, textarea, button, [tabindex="0"]');
        if (focusableElement) {
          setTimeout(() => {
            focusableElement.focus();
          }, 500);
        }
        
        setLastAddedId(null);
      }
    }
  }, [lastAddedId, items]);

  const handleDelete = (id) => {
    const itemToDelete = items.find(item => item.id === id);
    if (itemToDelete) {
      setDeletedItems(prev => [...prev, itemToDelete]);
    }
    
    setItems((prev) => prev.filter((i) => i.id !== id));
    
    onDelete && onDelete(id);
  };

  return (
    <div>
      <div className="d-flex gap-2 align-items-center mb-2">
        <h6 className="my-0">{label || 'Контент'}</h6>
        <DropdownButton
          onSelect={handleAddElement}
          variant="link"
          id="dropdown-content-items"
          title="Добавить элемент"
        >
          {Object.keys(CONTENT_ITEM_TYPES).map((i) => (
            <Dropdown.Item key={i} eventKey={i}>
              {CONTENT_ITEM_TYPES[i]}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="contentList">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <ContentItem
                      onChangeFile={handleFileChange}
                      onChangeSlider={handleSliderChange}
                      onDelete={handleDelete}
                      data={item}
                      onDragElement={provided.dragHandleProps}
                      {...provided.draggableProps}
                      ref={provided.innerRef}
                    />
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};
